import { motion, useReducedMotion } from "framer-motion";
import { useState } from "react";

const IMAGES = [
  {
    url: "/assets/install-house.webp",
    caption: "PTZ cameras — suburban home install",
    span: "md:col-span-5 md:row-span-2",
  },
  {
    url: "/assets/gallery-patch.webp",
    caption: "Patch panel build — commercial rack",
    span: "md:col-span-4",
  },
  {
    url: "/assets/gallery-rack-blue.webp",
    caption: "Cat6 cable dressing, dressed & labelled",
    span: "md:col-span-3",
  },
  {
    url: "/assets/gallery-alarm.webp",
    caption: "Alarm panel — ULC monitoring setup",
    span: "md:col-span-4",
  },
  {
    url: "/assets/install-dome.webp",
    caption: "Indoor dome camera, clean ceiling mount",
    span: "md:col-span-3",
  },
  {
    url: "/assets/install-bullet.webp",
    caption: "4K bullet camera on brick exterior",
    span: "md:col-span-7",
  },
  {
    url: "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxuZXR3b3JrJTIwY2FibGluZyUyMHNlcnZlciUyMHJhY2slMjBzdHJ1Y3R1cmVkfGVufDB8fHx8MTc4MzMyOTU0Nnww&ixlib=rb-4.1.0&q=85",
    caption: "Structured network cabling",
    span: "md:col-span-5",
  },
  {
    url: "/assets/lighting-rgb.webp",
    caption: "Colourful permanent roofline lighting",
  },
  {
    url: "/assets/lighting-warm.webp",
    caption: "Warm permanent eave lighting at night",
  },
  {
    url: "https://images.unsplash.com/photo-1544397838-37a35169ebf0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    caption: "Holiday lighting with illuminated landscaping",
  },
];

export const Gallery = () => {
  const reduceMotion = useReducedMotion();
  const [isMobile] = useState(() => window.matchMedia("(max-width: 767px)").matches);
  const columnsPerRow = isMobile ? 2 : 3;
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 lg:py-32">
      <div className="container-x">
        <motion.div
          initial={{ y: 24 }}
          whileInView={{ y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
        <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-brand-primary mb-4">
          Our Work
        </p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter leading-none text-zinc-900 max-w-xl">
          Recent installations across the province
        </h2>
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="origin-left mt-5 mb-14 h-1 w-20 rounded-full bg-gradient-to-r from-[#8C6D1F] via-[#D4AF37] to-[#E9C767]"
        />
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {IMAGES.map((img, i) => (
            <motion.figure
              key={img.caption}
              data-testid={`gallery-item-${i}`}
              initial={reduceMotion ? false : { opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{
                duration: 0.5,
                ease: "easeOut",
                delay: (i % columnsPerRow) * 0.08,
              }}
              className="group relative overflow-hidden rounded-xl border border-zinc-200 aspect-[4/3]"
            >
              <img
                src={img.url}
                alt={img.caption}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4 pt-10">
                <span className="text-xs sm:text-sm font-semibold text-white">{img.caption}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
